<script lang="ts">
    import type {SeekingDesiredExemplar} from 'typings/portaro.be.types';
    import KpDocumentMini from '../record/kp-document-mini/KpDocumentMini.svelte';

    export let desiredExemplar: SeekingDesiredExemplar;
</script>

<KpDocumentMini document={desiredExemplar.document}/>

{#if desiredExemplar.volume || desiredExemplar.page || desiredExemplar.article}
    <div>
        {#if desiredExemplar.volume}
            | <span>Ročník {desiredExemplar.volume}</span>
        {/if}
        {#if desiredExemplar.page}
            | <span>Strana {desiredExemplar.page}</span>
        {/if}
        {#if desiredExemplar.article}
            | <span>Článek {desiredExemplar.article}</span>
        {/if}
    </div>
{/if}

{#if desiredExemplar.note}
    <div>Pozn.: {desiredExemplar.note}</div>
{/if}